export const tmStoryGen52 = [

  {
    order: 1,
    title: "Route 19",
    where: "Route 19 – westlicher Teil der Route nahe dem Strandabschnitt, Itemball auf freier Fläche",
    requirements: { badgesNeeded: 0, badges: ["0 Orden"], hms: [] },
    notes: "TM94 Stärke"
  },

  {
    order: 2,
    title: "Floccesi-Ranch",
    where: "Floccesi-Ranch – hinter Zaunbereich im nördlichen Abschnitt, Itemball auf Grasfläche",
    requirements: { badgesNeeded: 0, badges: ["0 Orden"], hms: [] },
    notes: "TM21 Frustration"
  },

  {
    order: 3,
    title: "Virbank-Komplex",
    where: "Virbank-Komplex – Innenbereich des Kraftwerks, rechter Gang hinter Arbeiter",
    requirements: { badgesNeeded: 1, badges: ["1 Orden"], hms: [] },
    notes: "TM46 Diebeskuss"
  },

  {
    order: 4,
    title: "Route 4",
    where: "Route 4 – Wüstenbereich südlich von Rayono City, Itemball nahe Baugerüst",
    requirements: { badgesNeeded: 2, badges: ["2 Orden"], hms: [] },
    notes: "TM28 Schaufler"
  },

  {
    order: 5,
    title: "Wüstenresort",
    where: "Wüstenresort – südlicher Wüstenabschnitt nahe großer Felsformation",
    requirements: { badgesNeeded: 2, badges: ["2 Orden"], hms: [] },
    notes: "TM39 Felsgrab"
  },

  {
    order: 6,
    title: "Relikt-Schloss",
    where: "Relikt-Schloss – untere Ebene nach Treibsand-Bereich, Itemball im Seitenraum",
    requirements: { badgesNeeded: 2, badges: ["2 Orden"], hms: [] },
    notes: "TM30 Spukball"
  },

  {
    order: 7,
    title: "Route 16",
    where: "Route 16 – nördlicher Radwegabschnitt, erreichbar über Seitengang",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: [] },
    notes: "TM66 Vergeltung"
  },

  {
    order: 8,
    title: "Marea City",
    where: "Marea City – hinter Lagerhausbereich am Hafen",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: [] },
    notes: "TM55 Siedewasser"
  },

  {
    order: 9,
    title: "Route 5",
    where: "Route 5 – mittlerer Abschnitt, Itemball nahe Musiker-Duo",
    requirements: { badgesNeeded: 3, badges: ["3 Orden"], hms: [] },
    notes: "TM83 Bürde"
  },

  {
    order: 10,
    title: "Moor von Nevaio",
    where: "Moor von Nevaio – östlicher Moorbereich auf erhöhter Plattform",
    requirements: { badgesNeeded: 4, badges: ["4 Orden"], hms: [] },
    notes: "TM36 Matschbombe"
  },

  {
    order: 11,
    title: "Twist-Bergwerk",
    where: "Twist-Bergwerk – tieferer Höhlenabschnitt hinter Stärke-Rätsel",
    requirements: { badgesNeeded: 4, badges: ["4 Orden"], hms: ["Stärke"] },
    notes: "TM91 Lichtkanone"
  },

  {
    order: 12,
    title: "Route 7",
    where: "Route 7 – östlicher Brückenbereich nach Regenzone",
    requirements: { badgesNeeded: 5, badges: ["5 Orden"], hms: [] },
    notes: "TM81 Kreuzschere"
  },

  {
    order: 13,
    title: "Turm der Himmelsfeste",
    where: "Turm der Himmelsfeste – mittlere Etage nahe Trainer",
    requirements: { badgesNeeded: 5, badges: ["5 Orden"], hms: [] },
    notes: "TM61 Irrlicht"
  },

  {
    order: 14,
    title: "Route 13",
    where: "Route 13 – Küstenabschnitt westlich, Itemball auf Sandbank",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: ["Surfer"] },
    notes: "TM29 Psychokinese"
  },

  {
    order: 15,
    title: "Lentimas-Tunnel",
    where: "Lentimas-Tunnel – südlicher Nebenpfad nahe Felsvorsprung",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: [] },
    notes: "TM78 Bulldoze"
  },

  {
    order: 16,
    title: "Reverse Mountain",
    where: "Reverse Mountain – Lava-Bereich im südlichen Innenraum",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: [] },
    notes: "TM50 Überhitzer"
  },

  {
    order: 17,
    title: "Route 12",
    where: "Route 12 – Brückenbereich nahe Hochgras",
    requirements: { badgesNeeded: 6, badges: ["6 Orden"], hms: [] },
    notes: "TM53 Energieball"
  },

  {
    order: 18,
    title: "Route 9",
    where: "Route 9 – südlicher Stadtbereich vor Pokémon-Liga",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: [] },
    notes: "TM56 Schleuder"
  },

  {
    order: 19,
    title: "Route 11",
    where: "Route 11 – Grasfläche nördlich des Eingangs",
    requirements: { badgesNeeded: 7, badges: ["7 Orden"], hms: [] },
    notes: "TM03 Psychoschock"
  },

  {
    order: 20,
    title: "Route 23",
    where: "Route 23 – Wasserfall-Plateau hinter Stärke-Rätsel",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Stärke", "Kaskade"] },
    notes: "TM71 Steinkante"
  },

  {
    order: 21,
    title: "Siegesstraße",
    where: "Siegesstraße – mittlerer Höhlenabschnitt hinter Stärke-Block",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: ["Stärke"] },
    notes: "TM02 Drachenklaue"
  },

  {
    order: 22,
    title: "Siegesstraße",
    where: "Siegesstraße – oberer Bereich nahe Leiterverbindung",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: [] },
    notes: "TM26 Erdbeben"
  },

  {
    order: 23,
    title: "Riesengrotte",
    where: "Riesengrotte – äußerer Eisbereich auf freier Fläche",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: [] },
    notes: "TM13 Eisstrahl"
  },

  {
    order: 24,
    title: "Riesengrotte",
    where: "Riesengrotte – innerer Waldabschnitt im südlichen Bereich",
    requirements: { badgesNeeded: 8, badges: ["8 Orden"], hms: [] },
    notes: "TM24 Donnerblitz"
  },

];